const formatters=new Map();
const DAY=86400000;
export const calendarDay=(value,timeZone)=>{
  if(!formatters.has(timeZone)) formatters.set(timeZone,new Intl.DateTimeFormat('en-US',{timeZone,year:'numeric',month:'2-digit',day:'2-digit'}));
  const parts=Object.fromEntries(formatters.get(timeZone).formatToParts(new Date(value)).map(p=>[p.type,p.value]));
  return `${parts.year}-${parts.month}-${parts.day}`;
};
export const calendarMonth=(value,timeZone)=>{const [year,month]=calendarDay(value,timeZone).split('-').map(Number);return year*12+month-1;};
export const monthTitle=value=>new Intl.DateTimeFormat('en-US',{timeZone:'UTC',month:'long',year:'numeric'}).format(new Date(Date.UTC(Math.floor(value/12),value%12,1,12)));
export const dayTitle=(key,withYear=true)=>new Intl.DateTimeFormat('en-US',{timeZone:'UTC',weekday:'long',month:'long',day:'numeric',...(withYear?{year:'numeric'}:{})}).format(new Date(key+'T12:00:00Z'));
export function monthDays(value) {
  const year=Math.floor(value/12),month=value%12;
  const first=new Date(Date.UTC(year,month,1));const count=new Date(Date.UTC(year,month+1,0)).getUTCDate();
  const cells=Array(first.getUTCDay()).fill(null);
  for(let day=1;day<=count;day++)cells.push(`${year}-${String(month+1).padStart(2,'0')}-${String(day).padStart(2,'0')}`);
  while(cells.length%7)cells.push(null);
  return Array.from({length:cells.length/7},(_,row)=>cells.slice(row*7,row*7+7));
}
export function slotsByDay(slots,timeZone) {
  const result={};
  for(const slot of slots){const key=calendarDay(slot.start,timeZone);if(!result[key])result[key]=[];result[key].push(slot);}
  Object.values(result).forEach(items=>items.sort((a,b)=>Date.parse(a.start)-Date.parse(b.start)));
  return result;
}
export const availabilityWindow=(now,horizonDays)=>({from:now+60000,to:now+horizonDays*DAY});
